import { useMemo } from "react";
import { Checkbox } from "@/components/ui/checkbox";

export const withoutExcluded = (parsed, excluded) => parsed && ({
  ...parsed,
  top: { ...parsed.top, rows: parsed.top.rows.filter((r) => !excluded.has(r.id)) },
  cols: parsed.cols.map((c) => ({ ...c, rows: c.rows.filter((r) => !excluded.has(r.id)) })),
  footer: parsed.footer.filter((r) => !excluded.has(r.id)),
});

const groupsOf = (parsed) => [
  { id: "top", label: "Bloc du haut (semaine)", header: parsed.top.header, rows: parsed.top.rows },
  ...parsed.cols.map((c) => ({ id: c.id, label: "", header: c.header, rows: c.rows })),
  { id: "footer", label: "Équipes premières", header: "", rows: parsed.footer.map((r) => ({ ...r, time: `${r.day || ""} ${r.time}`.trim() })) },
].filter((g) => g.rows.length);

const MatchLine = ({ r, checked, onToggle, onSwap }) => (
  <label className={`flex cursor-pointer items-center gap-2 rounded px-1 py-0.5 hover:bg-secondary/60 ${checked ? "" : "opacity-40 line-through"}`}>
    <Checkbox checked={checked} onCheckedChange={onToggle} data-testid={`import-row-${r.id}`} />
    <span className="w-12 shrink-0 font-semibold">{r.cat}</span>
    <span className="min-w-0 flex-1 truncate">{r.match}{r.home_guess && <span className="ml-1 rounded bg-amber-500/20 px-1 text-[10px] text-amber-400" data-testid={`import-home-guess-${r.id}`}>domicile ?</span>}</span>
    {onSwap && r.match.includes(" - ") && (
      <button type="button" onClick={(e) => { e.preventDefault(); onSwap(r.id); }} title="Inverser domicile / extérieur" data-testid={`import-swap-${r.id}`}
        className="shrink-0 rounded border border-border px-1.5 text-[10px] hover:bg-secondary">⇄</button>
    )}
    <span className="shrink-0 text-muted-foreground">{r.time}</span>
  </label>
);

export const ImportPreview = ({ parsed, excluded, setExcluded, onSwap }) => {
  const groups = useMemo(() => groupsOf(parsed), [parsed]);
  const total = groups.reduce((n, g) => n + g.rows.length, 0);
  const toggle = (id) => setExcluded((s) => {
    const next = new Set(s);
    next.has(id) ? next.delete(id) : next.add(id);
    return next;
  });
  if (!total) return <p className="text-xs text-destructive" data-testid="import-preview-empty">Aucun match reconnu dans ce texte.</p>;
  return (
    <div className="space-y-2" data-testid="import-preview">
      <p className="text-xs font-medium" data-testid="import-preview-count">
        {total} match(s) trouvé(s) · <span className="text-primary">{total - excluded.size} à importer</span>
        <span className="text-muted-foreground"> — décochez ceux à ne pas mettre sur l'affiche</span>
      </p>
      <div className="max-h-[34vh] space-y-3 overflow-y-auto rounded-lg border border-border p-3 font-mono text-[11px]">
        {groups.map((g) => (
          <div key={g.id} data-testid={`import-group-${g.id}`}>
            <p className="mb-1 font-semibold text-primary">
              {g.label && <span className="mr-1 text-muted-foreground">{g.label} :</span>}{g.header || (g.label ? "" : "—")}
            </p>
            {g.rows.map((r) => <MatchLine key={r.id} r={r} checked={!excluded.has(r.id)} onToggle={() => toggle(r.id)} onSwap={g.id === "footer" ? undefined : onSwap} />)}
          </div>
        ))}
      </div>
    </div>
  );
};
